import { mapCommonFile } from './CommonFile.mappers';
export const mapSiteIcon = (file, baseFile) => {
  var _file$media, _file$media2;
  return {
    ...mapCommonFile(file, baseFile),
    mediaType: 'site_icon',
    width: ((_file$media = file.media) == null || (_file$media = _file$media.icon) == null || (_file$media = _file$media.image) == null ? void 0 : _file$media.width) || 0,
    height: ((_file$media2 = file.media) == null || (_file$media2 = _file$media2.icon) == null || (_file$media2 = _file$media2.image) == null ? void 0 : _file$media2.height) || 0
  };
};
//# sourceMappingURL=SiteIcon.mappers.js.map